import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted, ref } from 'vue';

interface Countdown {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CountdownTimer',
  props: {
    dateTime: null
  },
  setup(__props: any) {

const props = __props as {
	dateTime: Date;
};



const emptyCountdown: Countdown = {
	days: 0,
	hours: 0,
	minutes: 0,
	seconds: 0,
};

let interval: number | NodeJS.Timeout | null = null;
const countdown = ref<Countdown>({ ...emptyCountdown });

// const timestamp = '2024-11-12T23:11:00+01:00';

onMounted((): void => {
	calculateCountdown();
	interval = setInterval(calculateCountdown, 1000);
});

onBeforeUnmount((): void => {
	if (interval !== null) clearInterval(interval as number);
});

const calculateCountdown = (): void => {
	const now: Date = new Date();
	const eventDate: Date = new Date(props.dateTime);
	const timeDiff: number = eventDate.getTime() - now.getTime();

	if (timeDiff > 0) {
		countdown.value.days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
		countdown.value.hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
		countdown.value.minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
		countdown.value.seconds = Math.floor((timeDiff / 1000) % 60);
	} else {
		// Clear interval when countdown ends
		clearInterval(interval as number);

		// Set the values to 0
		countdown.value = { ...emptyCountdown };
	}
};

return { __sfc: true,props, emptyCountdown, interval, countdown, calculateCountdown }
}

})